import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';

/**
 * A message across a page or a section, coloured by its type, with an optional description and ×:
 *
 *     <gains-banner type="warning" message="Configuration warnings" [description]="warningsTpl" [closeable]="true"
 *       (closed)="dismiss()"></gains-banner>
 *
 * `loading` shows a spinner instead of the type's icon, for something still running.
 */
@Component({
  selector: 'gains-banner',
  standalone: false,
  template: `<nz-alert
      [nzType]="type"
      [nzMessage]="message"
      [nzDescription]="description ?? null"
      [nzCloseable]="closeable"
      [nzIcon]="icon"
      nzShowIcon
      (nzOnClose)="closed.emit()"
    ></nz-alert>
    <ng-template #icon>
      <svg-icon class="gap-icon" [class.gap-icon-spin]="loading" [src]="iconSrc" aria-hidden="true"></svg-icon>
    </ng-template>`,
  styles: [':host { display: block; }']
})
export class GainsBannerComponent {
  @Input() type: 'success' | 'info' | 'warning' | 'error' = 'info';
  @Input({ required: true }) message!: string | TemplateRef<void>;
  @Input() description?: string | TemplateRef<void>;
  @Input() closeable = false;
  @Input() loading = false;
  @Output() closed = new EventEmitter<void>();

  /** The type's icon, from the GAP set; a spinner while loading. */
  get iconSrc(): string {
    return `assets/icons/${this.loading ? 'loading.svg' : ICONS[this.type]}`;
  }
}

const ICONS: Record<GainsBannerComponent['type'], string> = {
  success: 'circle-check.svg',
  info: 'circle-info.svg',
  warning: 'triangle-warning.svg',
  error: 'circle-xmark.svg'
};
